import { render, staticRenderFns } from "./batchPayConfirm.vue?vue&type=template&id=fd2638ac&scoped=true"
import script from "./batchPayConfirm.vue?vue&type=script&lang=js"
export * from "./batchPayConfirm.vue?vue&type=script&lang=js"
import style0 from "./batchPayConfirm.vue?vue&type=style&index=0&id=fd2638ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2638ac",
  null
  
)

export default component.exports